import React from 'react'

export default class ChartBuilderNavSteps extends React.Component {
  constructor(props){
    super(props);
  };

  render(){
    if (this.props.report_details && this.props.report_details.chart_type){
      return (
        <div className="steps">
          {this.renderChartTypeSteps()}
          <br />
        </div>
      );
    } else {
      return null
    }
  };

  renderChartTypeSteps(){
    switch(true){
      case this.props.report_details.chart_type.name === 'line_chart' || this.props.report_details.chart_type.name === 'area_chart' || this.props.report_details.chart_type.name === 'vertical_bar_chart' || this.props.report_details.chart_type.name === 'stacked_bar_chart':
        return(
          <ul className="nav nav-wizard">
            <li className={this.props.step == "general" ? 'active' : ''}><a href="#general" data-step="general" >{I18n.t("general")}</a></li>
            <li className={this.props.step == "primary_axis_details" ? 'active' : ''}><a href="#x-axis-details" data-step="x-axis-details" >{I18n.t("horizontal_axis_details")}</a></li>
            <li className={this.props.step == "secondary_axis_details" ? 'active' : ''}><a href="#y-axis-details" data-step="y-axis-details" >{I18n.t("vertical_axis_details")}</a></li>
            <li className={this.props.step == "preview_chart" ? 'active' : ''}><a href="#preview-chart" data-step="preview_chart" >{I18n.t("preview_chart")}</a></li>
          </ul>
        );
      case this.props.report_details.chart_type.name === 'dual_axis_line_chart':
        return(
          <ul className="nav nav-wizard">
            <li className={this.props.step == "general" ? 'active' : ''}><a href="#general" data-step="general" >{I18n.t("general")}</a></li>
            <li className={this.props.step == "primary_axis_details" ? 'active' : ''}><a href="#x-axis-details" data-step="x-axis-details" >{I18n.t("horizontal_axis_details")}</a></li>
            <li className={this.props.step == "secondary_axis_details" ? 'active' : ''}><a href="#y-axis-details" data-step="y-axis-details" >{I18n.t("vertical_axis_details")}</a></li>
            <li className={this.props.step == "second_y_axis" ? 'active' : ''}><a href="#second-y-axis-details" data-step="second_y_axis" >{I18n.t("second_vertical_axis")}</a></li>
            <li className={this.props.step == "preview_chart" ? 'active' : ''}><a href="#preview-chart" data-step="preview_chart" >{I18n.t("preview_chart")}</a></li>
          </ul>
        );
      case this.props.report_details.chart_type.name === 'horizontal_bar_chart':
        return (
          <ul className="nav nav-wizard">
            <li className={this.props.step == "general" ? 'active' : ''}><a href="#general" data-step="general" >{I18n.t("general")}</a></li>
            <li className={this.props.step == "primary_axis_details" ? 'active' : ''}><a href="#x-axis-details" data-step="x-axis-details" >{I18n.t("vertical_axis_details")}</a></li>
            <li className={this.props.step == "secondary_axis_details" ? 'active' : ''}><a href="#y-axis-details" data-step="y-axis-details" >{I18n.t("horizontal_axis_details")}</a></li>
            <li className={this.props.step == "preview_chart" ? 'active' : ''}><a href="#preview-chart" data-step="preview_chart" >{I18n.t("preview_chart")}</a></li>
          </ul>
        );
    };
  };
};